import { render } from "./ImageDisplay.vue?vue&type=template&id=8cc07f5c"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__